const en = {
  code: 'en',
  short: 'EN',
  label: 'English',
  native: 'English',
  hero: {
    badge: 'Cleaning Services • Bratislava',
    title: 'Clean space. Clear head.',
    lead: 'Reliable residential & office cleaning with transparent pricing and simple booking.',
    cta: 'Book Now',
    whatsapp: 'WhatsApp'
  },
  header: {
    home: 'Home',
    services: 'Services',
    contact: 'Contact',
    book: 'Book Now',
    whatsapp: 'WhatsApp',
    language: 'Language'
  },
  home: {
    licensed: 'Licensed • Insured • Supplies included',
    firstCleanDiscountBadge: '10%',
    firstCleanDiscount: 'off your first cleaning',
    servicesTitle: 'Our Services',
    seeDetails: 'See details →',
    whyTitle: 'Why Sparklean?',
    reasons: [
      'Reliable, vetted team of specialists',
      'Pros with references and proven experience',
      'Flexible slots incl. evenings',
      'Fixed quotes, no hidden fees'
    ],
    areaTitle: 'Areas we cover',
    areaCopy: 'Bratislava and nearby area.',
    quote: 'Get a Quote'
  },
  optional: 'optional',
  servicesPage: {
    title: 'Services',
    subtitle: 'Click a card to open the dedicated page with full checklists, gallery, and pricing notes.'
  },
  notFound: {
    message: 'Page not found.',
    back: 'Go home'
  },
  serviceDetail: {
    notFound: 'Service not found',
    back: 'Back to Services',
    bookThis: 'Book this service',
    allServices: 'All services'
  },
  contact: {
    title: 'Contact',
    hours: 'We answer Mon–Sat 8:00–20:00.',
    emailLabel: 'Email',
    phoneLabel: 'Phone',
    whatsappAvailable: 'WhatsApp available',
    whatsapp: 'Message on WhatsApp',
    email: 'Send Email',
    office: 'Office',
    address: 'Karpatské námestie 10A, Bratislava, Slovakia'
  },
  booking: {
    title: 'Booking',
    subtitle: 'Tell us about your space and schedule. We will confirm by email or WhatsApp.',
    fullName: 'Full name',
    fullNamePlaceholder: 'Jane Doe',
    serviceField: 'Service',
    dateField: 'Preferred date',
    datePlaceholder: 'DD-MM-YYYY',
    timeField: 'Preferred time',
    nameField: 'Name',
    emailField: 'Email',
    phoneField: 'Phone',
    phonePlaceholder: '+421 900 000 000',
    addressField: 'Address',
    addressPlaceholder: 'Street, number, district',
    notesField: 'Notes',
    notesPlaceholder: 'Pets at home, parking info, gate code, etc.',
    submit: 'Send request',
    chooseService: 'Choose a service',
    pick: 'Pick',
    successTitle: 'Request sent ✅',
    successLine: 'Thanks! Your reference:',
    successNote: 'We’ll confirm by email/WhatsApp shortly.',
    calendarMonth: 'long',
    pickerDescription: 'Select the type of cleaning you need.',
    pickerTip: 'Tip: You can change this later.',
    whatsappAlt: 'or WhatsApp us',
    privacy: 'We keep your data private. By submitting, you agree to being contacted about this request.',
    error: 'Something went wrong. Please try again.',
    errorTitle: 'Request not sent',
    errorMessage: 'We couldn’t send your request. Please try again or contact us directly.',
    errorWhatsapp: 'Open WhatsApp chat',
    errorEmail: 'Email us instead',
    required: 'This field is required',
    emailError: 'Enter a valid email',
    phoneError: 'Use digits, +, space or dash',
    minChars: 'Minimum 10 characters',
    addressHint: 'Enter street and number',
    pickerTitle: 'Select a service',
    calendarTitle: 'Pick a date'
  },
  footer: {
    tagline: 'Professional cleaning services in Bratislava and nearby areas.',
    rights: 'All rights reserved.',
    getInTouch: 'Get in touch',
    chat: 'Chat on WhatsApp'
  },
  services: [
    {
      slug: 'regular-cleaning',
      title: 'Regular Cleaning',
      short: 'Keep your space clean and fresh on a daily or weekly basis.',
      intro: 'Regular cleaning helps maintain cleanliness and order in your home.',
      description: [
        'Our team ensures thorough vacuuming and mopping of all accessible areas, careful dusting of reachable surfaces, and deep cleaning of kitchen and bathroom fixtures — leaving your home fresh, spotless, and comfortable.',
        'Recommended frequency: weekly, bi-weekly, or monthly.'
      ],
      bullets: [
        'Floors vacuumed and mopped',
        'Dusting of reachable surfaces',
        'Bathroom and kitchen fixtures sanitised',
        'Bins emptied and liners replaced'
      ],
      priceNote: '€18 / hour • Minimum 2 hours'
    },
    {
      slug: 'general-cleaning',
      title: 'General Cleaning',
      short: 'Perfect balance between regular and deep cleaning for a well-maintained home.',
      intro: 'A more detailed cleaning that goes beyond regular maintenance.',
      description: [
        'We include all steps of regular cleaning plus thorough kitchen and bathroom care, covering exterior surfaces, interior oven and refrigerator cleaning, and dedicated pet area refreshes.',
        'Recommended frequency: weekly, every two weeks, or once a month.'
      ],
      bullets: [
        'Regular cleaning checklist included',
        'Kitchen and bathroom detailing',
        'Oven and fridge interior cleaning',
        'Removal of pet hair and cleaning of pet areas (feeding spot, litter box area)'
      ],
      priceNote: '€20 / hour • Minimum 2 hours'
    },
    {
      slug: 'deep-cleaning',
      title: 'Deep Cleaning',
      short: 'Complete top-to-bottom cleaning for maximum freshness.',
      intro: 'The most detailed cleaning service focused on hard-to-reach areas, deep sanitation, and appliances.',
      description: [
        'Our service includes every step of general cleaning, plus inside-and-outside window cleaning where reachable, interior cleaning of wardrobes and cabinets, and deep treatment of kitchen appliances such as the fridge, oven, and microwave.',
        'Upon request, balcony cleaning is also available. Recommended whenever you want your home to feel perfectly refreshed.'
      ],
      bullets: [
        'Detailed limescale and grease removal',
        'Cabinets and wardrobes cleaned inside',
        'Windows cleaned inside and outside (reachable)',
        'Appliances deep-cleaned throughout'
      ],
      priceNote: '€22 / hour • Minimum 2 hours'
    },
    {
      slug: 'post-construction-cleaning',
      title: 'Post-Construction Cleaning',
      short: 'Remove dust, paint, and debris after renovation.',
      intro: 'Professional cleaning after renovation or construction work.',
      description: [
        'We remove dust, glue, paint, and debris, clean windows, floors, surfaces, and bathrooms so the property is move-in ready — fresh, spotless, and dust-free.'
      ],
      bullets: [
        'Removal of construction dust and debris',
        'Detailing of fixtures, sockets, and switches',
        'Window, frame, and sill cleaning',
        'Final polish of floors and surfaces'
      ],
      priceNote: 'Custom quote after walkthrough'
    },
    {
      slug: 'move-in-move-out',
      title: 'Move-In / Move-Out Cleaning',
      short: 'Ideal for new beginnings or smooth transitions.',
      intro: 'Detailed cleaning to help you hand over or move into a spotless home.',
      description: [
        'We focus on cupboards, appliances, skirting boards, and fixtures to make sure the property is immaculate for landlords or new owners.',
        'Perfect before listing, inspections, or settling into a new space.'
      ],
      bullets: [
        'Cabinets and drawers cleaned inside',
        'Appliance interiors degreased',
        'Windows and frames wiped down',
        'Attention to details such as baseboards and switches'
      ],
      priceNote: 'Fixed quotes after quick inspection'
    },
    {
      slug: 'office-cleaning',
      title: 'Office Cleaning',
      short: 'Keep your workspace spotless and productive.',
      intro: 'Maintain a pristine and organised workspace with our professional office cleaning service.',
      description: [
        'We ensure thorough cleaning of all areas — from workstations and meeting rooms to kitchens and sanitary facilities — creating a spotless and hygienic environment.',
        'Our trained team works with precision and discretion, helping your company maintain a professional image and a comfortable atmosphere for employees and clients.'
      ],
      bullets: [
        'Workstations, meeting rooms, and reception areas',
        'Washrooms and kitchenettes sanitised',
        'Bins emptied and recycling managed',
        'Flexible schedules outside working hours'
      ],
      priceNote: 'Pricing on request'
    },
    {
      slug: 'commercial-cleaning',
      title: 'Commercial Cleaning',
      short: 'Professional service for restaurants, hotels, and shops.',
      intro: 'Create a spotless and welcoming environment for your customers and staff.',
      description: [
        'We provide high-standard cleaning for restaurants, hotels, shops, salons, fitness centres, and offices, ensuring every area looks pristine and feels hygienic.',
        'Our trained team focuses on detail — from shining floors and polished furniture to disinfected kitchens and restrooms. We use eco-friendly solutions and reliable methods to guarantee safety, freshness, and comfort in your business space.',
        'Sparklean offers flexible schedules and personalised cleaning plans to suit your working hours, ensuring minimal disruption to your operations.'
      ],
      bullets: [
        'Front-of-house, back-of-house, and storage areas',
        'Disinfection of high-touch surfaces',
        'Floor care for hard surfaces and carpets',
        'Custom schedules for each business type'
      ],
      priceNote: 'Pricing on request'
    },
    {
      slug: 'window-cleaning',
      title: 'Window Cleaning',
      short: 'Crystal-clear windows inside and out.',
      intro: 'Crystal-clear windows make every space brighter.',
      description: [
        'Our team provides professional window cleaning services for apartments, offices, and commercial spaces — both inside and outside (reachable areas only).',
        'We use eco-friendly and streak-free products, leaving glass spotless and frames shining without damage. Regular window cleaning enhances natural light, creates a fresh atmosphere, and keeps your space looking professional.'
      ],
      bullets: [
        'Interior and reachable exterior glass',
        'Frames, sills, and tracks wiped',
        'Streak-free, eco-friendly products',
        'Ideal for homes, offices, and storefronts'
      ],
      priceNote: '€25 / hour • Minimum 2 hours'
    },
    {
      slug: 'carpet-upholstery-cleaning',
      title: 'Carpet & Upholstery Cleaning',
      short: 'Deep cleaning and refreshing of carpets and upholstered furniture.',
      intro: 'Restore softness and remove odours from carpets, sofas, and chairs.',
      description: [
        'We treat stains, allergens, and build-up with professional equipment tailored to fabric type, leaving textiles revitalised and fresh.',
        'Ideal as an add-on to deep cleaning or as a standalone refresh for high-traffic homes and commercial lounges.'
      ],
      bullets: [
        'Hot-water extraction or low-moisture methods',
        'Targeted stain and odour removal',
        'Safe solutions for delicate fabrics',
        'Fast drying times to reduce downtime'
      ],
      priceNote: 'Quote based on fabric type and area size'
    }
  ]
};

export default en;
